import React, { forwardRef } from 'react'
import styled from 'styled-components'

import { ErrorMessage } from '../../components/ErrorMessage'
import { Label } from '../../components/Label'
import { SpinnerIcon } from '../../components/Icons/Spinner'

const getDynamicWidth = (value, placeholder) => {
  if (placeholder && !value) {
    return placeholder.length * 10 + 5
  }

  return value.length * 10 + 5
}

export const StyledInput = styled.input`
  width: ${(props) =>
    props.hasDynamicWidth ? `${getDynamicWidth(props.value, props.placeholder)}px` : 'calc(100% - 42px)'};
  font-size: ${(props) => (props.small ? '14px' : '16px')};
  color: #1b1b3d;
  outline: none;
  border-radius: 3px;
  background-color: ${({readOnly, disabled}) => (readOnly || disabled ? '#f2f2f2' : '#ffffff')};
  padding: ${(props) => (props.noPadding ? '0px' : props.small ? '5px 10px' : '12px 20px')};
  border-style: solid;
  border-width: 1px;
  border-color: ${(props) => (props.showError ? '#f52e2e' : '#9999bd')};
  cursor: ${({readOnly, disabled}) => (readOnly || disabled ? 'not-allowed' : 'initial')};
  ${(props) => {
    return props.noBorder
      ? `
      border: none;
    `
      : ''
  }}

  &:focus {
    border-color: ${({readOnly, disabled}) => (readOnly || disabled ? '#9999bd' : '#80deea')};
  }
`

const InputWrapper = styled.div`
  position: relative;
`

const StyledSpinnerIcon = styled(SpinnerIcon)`
  position: absolute;
  top: 6px;
  right: 25px;
  fill: #5d5c70;
`

export const Input = forwardRef((props, ref) => {
  const { touched, errors, label, loading, icon, ...inputProps } = props
  const showError = touched && errors

  return (
    <label>
      {label && <Label>{label}</Label>}
      <InputWrapper>
        <StyledInput ref={ref} showError={showError} {...inputProps} />
        {icon}
        {loading && <StyledSpinnerIcon />}
      </InputWrapper>
      {showError && <ErrorMessage>{errors}</ErrorMessage>}
    </label>
  )
})
